<template>
    <div class="main">

        <c-panel>
            <el-row :gutter="10">
                <el-col :xs="24" :sm="24" :md="24">
                    <label>Relatórios</label>
                    <el-select v-model="tipo">
                        <el-option :key="1" label="PENDÊNCIAS DE FREQUÊNCIA" :value="1"></el-option>
                        <el-option :key="2" label="PENDÊNCIAS DE CONTEÚDO" :value="2"></el-option>
                    </el-select>
                </el-col>
            </el-row>
        </c-panel>

        <div class="u-mt-10">
            <pendencias v-if="tipo == 1 || tipo == 2" :tipo-pendencia="tipo"></pendencias>
        </div>

        
    </div>
</template>
<script>

import pendencias from "./pendencias"

export default {
    data: () => ({
        tipo: 1        
    }),
    mounted () {

    },
    methods: {     
        text(){
            
        }
    },
    components:{ pendencias }
}
</script>
